const bottomSheet = {
  show({
    title,
    values,
  }, delay = 100) {
    setTimeout(() => {
      globalThis.$events.$emit("app-bottom-sheet", {
        component: "app-bottom-list",
        title,
        values,
      });
    }, delay);
  },

  dismiss() {
    globalThis.$events.$emit("app-bottom-sheet", { dismiss: true });
  },
};

globalThis.$bottomSheet = bottomSheet;

export default {
  install(Vue) {
    Vue.prototype.$bottomSheet = bottomSheet;
  },
};
